import cx from 'classnames';

import {ProgressBar, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';
import {getNormalizedLifestyleScore} from '#util/lifestyleScore';

import {CategoryListProps} from './CategoryList.types';

/**
 * This component renders a list of "preview" scores for each category of the
 * users most recently-created labSubmission's surveyAssessment.
 */
export const CategoryList = ({categories = [], className, ...otherProps}: CategoryListProps) => (
  <ul className={cx(sprinkles({flex: 'flex', dir: 'col', gap: 24}), className)} {...otherProps}>
    {categories.map(({id, title, categoryScore, maxCategoryScore}) => (
      <li className={sprinkles({flex: 'flex', dir: 'col', gap: 8})} key={id}>
        <span className={sprinkles({flex: 'flex', content: 'between'})}>
          <Text>{title}</Text>
          <Text fontWeight="semiBold">
            {getNormalizedLifestyleScore(categoryScore, maxCategoryScore)}
          </Text>
        </span>

        <ProgressBar
          aria-label={`${title} category score`}
          value={categoryScore}
          maxValue={maxCategoryScore}
        />
      </li>
    ))}
  </ul>
);
